export default "__VITE_ASSET__C$E0qtUD__"